module.exports = __webpack_public_path__ + "img/house_msg.a9c57a62.png";